import { Component, ChangeDetectorRef, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { TipoFirmante } from '../../../../envios/models/tipo-firmante';
import { FirmanteNif } from '../../../models/firmante-nif';
import { DatosConfiguracionDocumentosService } from '../../../services/datos-configuracion-documentos.service';
import { FormularioDocumentoService } from '../../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../../services/formulario-validaciones-docs.service';
import { CasillasTemporalComponent } from '../casillas-temporal/casillas-temporal.component';
import {
  firmanteColorCssVars,
} from '../../configuracion-panel-firmantes-unificado/firmante-color.tokens';

@Component({
  selector: 'app-formularios-grupo-casillas',
  templateUrl: './formularios-grupo-casillas.component.html',
  styleUrls: ['./formularios-grupo-casillas.component.css']
})
export class FormulariosGrupoCasillasComponent implements OnInit, OnDestroy {

  @Input() firmante: any;
  @Output() addForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() enviarInput: EventEmitter<any> = new EventEmitter<any>();
  @Input() formulario: FormGroup;
  @Input() indexMostrar: number;
  @Input() inlineMode = false;
  @ViewChild('radio') radio: ElementRef;
  @ViewChild('formulariosGrupoCasillasComponent') formulariosGrupoCasillasComponent: FormulariosGrupoCasillasComponent;

  @ViewChild('botonAnadir') botonAnadir: ElementRef;

  posicionBoton: { left: number, top: number, height: number, width: number };
  posicionCasilla: {
    mostrar: boolean,
    left: number,
    top: number,
    firmante: TipoFirmante,
    nombre: string,
    orden: number,
    valorOpcionSeleccionada: string,
    obligatorio: boolean,
    idNombreFormulario: number | null
  } = {mostrar: false, left:0, top:0, firmante:{codigo:'', desc:''}, nombre:'', orden: null, valorOpcionSeleccionada:'', obligatorio: false,idNombreFormulario: null}

  casillaMoverArray: any[] = [];
  private formularioHighlightSubscription: Subscription;
  private validacionFormulariosRevisionSubscription: Subscription;
  @ViewChild('casillasTemporalComponent') casillasTemporalComponent: CasillasTemporalComponent;

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              private cdr: ChangeDetectorRef,
              private _snackBar: MatSnackBar) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['firmante']) {
      return;
    }
    const firmanteInput = changes['firmante'].currentValue;
    if (firmanteInput?.tipoFirmante) {
      this.posicionCasilla.firmante = firmanteInput.tipoFirmante;
    } else if (firmanteInput?.codigo != null) {
      this.posicionCasilla.firmante = firmanteInput;
    }
  }

  ngOnInit(): void {
    this.formularioHighlightSubscription = this.datosConfiguracionDocumentosService.datosFormularioHighlight$.subscribe(() => {
      this.cdr.markForCheck();
    });
    // Al marcar errores desde Finalizar/Siguiente el FormGroup cambia pero el
    // template no se reevalua hasta forzar deteccion de cambios.
    this.validacionFormulariosRevisionSubscription =
      this.formularioValidacionesDocsService.validacionFormulariosRevision$.subscribe(() => {
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy(): void {
    this.formularioHighlightSubscription?.unsubscribe();
    this.validacionFormulariosRevisionSubscription?.unsubscribe();
  }

  get nombre(){ return this.formulario.controls['nombre']}
  get orden(){
    const codigo = this.firmante?.tipoFirmante?.codigo;
    const idNombre = this.idNombreFormulario?.value;
    if (codigo == null || idNombre == null) {
      return null;
    }
    return this.formularioDocumentoService.countCasillasColocadasEnGrupo(codigo, idNombre) || null;
  }
  get idForm(){ return this.idNombreFormulario}
  get obligatorio(){ return this.formulario.controls['obligatorio']}
  get valorOpcionSeleccionada(){ return this.formulario.controls['valorOpcionSeleccionadaPorDefecto']}
  get formularios(){ return this.formularioDocumentoService.firmantesNif.at(this.obtenerIndexNifArray()).get('formularios') as FormArray}
  get idNombreFormulario(){ return this.formulario.controls['idNombreFormulario']}

  get firmanteCodigo(): string | undefined {
    return this.firmante?.tipoFirmante?.codigo ?? this.firmante?.codigo;
  }

  get estaSeleccionado(): boolean {
    const highlight = this.datosConfiguracionDocumentosService.getFormularioHighlight();
    if (!highlight || this.firmanteCodigo == null) {
      return false;
    }
    return (
      highlight.firmanteCodigo === this.firmanteCodigo &&
      highlight.idNombreFormulario === this.idNombreFormulario?.value
    );
  }

  get firmanteCssVars(): Record<string, string> {
    return this.firmanteCodigo ? firmanteColorCssVars(this.firmanteCodigo) : {};
  }

  onHighlightCheckboxChange(event: Event): void {
    event.stopPropagation();
    const codigo = this.firmanteCodigo;
    const idNombre = this.idNombreFormulario?.value;
    if (codigo == null || idNombre == null) {
      return;
    }
    this.datosConfiguracionDocumentosService.toggleFormularioHighlight(codigo, idNombre);
  }

  addFormulario(){
    this.addForm.emit();
  }

  deleteFormulario(){
    this.deleteForm.emit({
      nombre: this.nombre.value,
      idNombreFormulario: this.idNombreFormulario?.value,
    });
  }

  /** Persiste el nombre en el borrador sin validar (se valida en blur). */
  sincronizarNombreEnBorrador(): void {
    const firmanteCodigo = this.firmante?.tipoFirmante?.codigo;
    const idNombre = this.idNombreFormulario?.value;
    if (firmanteCodigo != null && idNombre != null) {
      this.formularioDocumentoService.actualizarBorrador(firmanteCodigo, idNombre, {
        nombre: this.nombre.value ?? '',
      });
    }
  }

  onNombreBlur(): void {
    this.sincronizarNombreEnBorrador();
    this.validarNombreFormulario(true);
  }

  /**
   * Valida duplicados intra- y entre-firmantes. Solo en blur (o al anadir casilla)
   * se marca touched y se muestra snackbar; asi no hay doble aviso ni se pierde
   * el estado de error al salir del campo.
   */
  private validarNombreFormulario(mostrarSnackbar: boolean): void {
    const indexNif = this.obtenerIndexNifArray();
    if (indexNif <= -1) {
      return;
    }
    this.formularioValidacionesDocsService.actualizarErroresNombreFormularioDuplicado(indexNif);
    this.formularioValidacionesDocsService.actualizarErroresNombreFormularioDuplicadoEntreFirmantes();

    const duplicadoMismoFirmante = this.formularioValidacionesDocsService.esNombreFormularioDuplicado(
      this.formulario,
      indexNif
    );
    const duplicadoEntreFirmantes = this.formularioValidacionesDocsService.tieneNombreFormularioDuplicadoEntreFirmantes(
      this.formulario
    );

    if (duplicadoMismoFirmante || duplicadoEntreFirmantes) {
      this.formularioValidacionesDocsService.marcarNombresFormularioDuplicadosComoTouched();
    } else {
      this.nombre.markAsTouched();
      this.formulario.markAsTouched();
      this.cdr.detectChanges();
    }

    if (mostrarSnackbar && duplicadoMismoFirmante) {
      this._snackBar.open(
        'El nombre del formulario ya existe. Elija otro nombre.',
        'Cerrar',
        { duration: 4000 }
      );
    } else if (mostrarSnackbar && duplicadoEntreFirmantes) {
      const etiqueta = this.formularioValidacionesDocsService.obtenerEtiquetaFirmanteConflicto(this.formulario);
      this._snackBar.open(
        etiqueta
          ? `El nombre del formulario ya lo usa ${etiqueta}. Elija otro nombre.`
          : 'El nombre del formulario ya existe en otro firmante. Elija otro nombre.',
        'Cerrar',
        { duration: 4000 }
      );
    }
  }

  onObligatorioChange(event: Event): void {
    const checked = (event.target as HTMLInputElement)?.checked ?? !!this.obligatorio.value;
    const firmanteCodigo = this.firmante?.tipoFirmante?.codigo;
    const idNombre = this.idNombreFormulario?.value;
    if (firmanteCodigo != null && idNombre != null) {
      this.formularioDocumentoService.actualizarBorrador(firmanteCodigo, idNombre, { obligatorio: checked });
    }
  }

  obtenerIndexNifArray():number{
    return this.formularioDocumentoService.firmantesNif.value.findIndex((x:FirmanteNif) => x.tipoFirmante.codigo == this.firmante.tipoFirmante.codigo)
  }

  getPosicion(event:any){
    this.sincronizarNombreEnBorrador();
    const indexNif = this.obtenerIndexNifArray();
    if (indexNif > -1) {
      this.formularioValidacionesDocsService.actualizarErroresNombreFormularioDuplicado(indexNif);
      this.formularioValidacionesDocsService.actualizarErroresNombreFormularioDuplicadoEntreFirmantes();
    }

    if(this.nombre.value == null || this.nombre.value == ''){
      this._snackBar.open(`Se tiene que informar el nombre del formulario antes de dibujar los campos.`,'Cerrar', {duration: 4000});
    }else if(indexNif > -1 && this.formularioValidacionesDocsService.esNombreFormularioDuplicado(this.formulario, indexNif)){
      this.formularioValidacionesDocsService.marcarNombresFormularioDuplicadosComoTouched();
      this._snackBar.open('El nombre del formulario está duplicado, no se pueden añadir casillas hasta que se cambie el nombre.', 'Cerrar', {duration: 5000});
    }else if(indexNif > -1 && this.formularioValidacionesDocsService.tieneNombreFormularioDuplicadoEntreFirmantes(this.formulario)){
      this.formularioValidacionesDocsService.marcarNombresFormularioDuplicadosComoTouched();
      const etiqueta = this.formularioValidacionesDocsService.obtenerEtiquetaFirmanteConflicto(this.formulario);
      this._snackBar.open(
        etiqueta
          ? `El nombre del formulario ya lo usa ${etiqueta}. No se pueden añadir casillas hasta que se cambie el nombre.`
          : 'El nombre del formulario ya existe en otro firmante. No se pueden añadir casillas hasta que se cambie el nombre.',
        'Cerrar',
        { duration: 5000 }
      );
    }else{
      const {left, top, height, width} = this.botonAnadir.nativeElement.getBoundingClientRect();
      this.posicionBoton = {left, top, height, width};
      this.posicionCasilla = {
        mostrar: true,
        left: this.posicionBoton.left,
        top: this.posicionBoton.top,
        firmante: this.firmante?.tipoFirmante ?? this.posicionCasilla.firmante,
        nombre: this.nombre.value,
        orden: this.orden,
        // New casillas must start with empty option value; do not inherit from existing row.
        valorOpcionSeleccionada: '',
        obligatorio: this.obligatorio?.value ?? false,
        idNombreFormulario: this.idNombreFormulario?.value
      }
      this.casillaMoverArray.push(this.posicionCasilla)

      //solo puede haber un elemento al momento de moverse. Si se ha creado uno y no se ha movido, lo borramos al crear el segundo
      if(this.casillaMoverArray.length > 1){
      this.casillaMoverArray.shift();
      }
    }
  }
}
